import { SERVICES as PART1 } from "@/data/services-part1";
import { SERVICES_PART2 as PART2 } from "@/data/services-part2";

export const SERVICES = { ...PART1, ...PART2 };
export const SERVICE_LIST = Object.values(SERVICES);
